"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWaveCreditNft } from "@/generated/models/ApiWaveCreditNft";
import { useMemo, useState } from "react";
import WaveRatingCardSetTdhDialog from "./WaveRatingCardSetTdhDialog";
import { getMemeCardCountLabel, normalizeCardSetTdhTokenIds } from "./wave-card-set-tdh.helpers";
interface WaveRatingCardSetTdhProps {
  readonly creditNfts: readonly ApiWaveCreditNft[] | null | undefined;
}
export default function WaveRatingCardSetTdh(t0) {
  const $ = _c(18);
  const {
    creditNfts
  } = t0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] !== creditNfts) {
    t1 = normalizeCardSetTdhTokenIds(creditNfts);
    $[0] = creditNfts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tokenIds = t1;
  let t2;
  if ($[2] !== tokenIds.length) {
    t2 = getMemeCardCountLabel(tokenIds.length);
    $[2] = tokenIds.length;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const countLabel = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-font-medium tw-text-iron-200">Card Set TDH</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== countLabel) {
    t4 = <span className="tw-text-iron-300">{countLabel}</span>;
    $[5] = countLabel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-text-iron-500" aria-hidden="true">·</span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <button type="button" className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0 tw-font-medium tw-text-primary-300 tw-transition-colors hover:tw-text-primary-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-400/40" onClick={() => setIsDialogOpen(true)}>View set</button>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4) {
    t7 = <div className="tw-flex tw-w-full tw-flex-col tw-items-end tw-gap-1 tw-text-right tw-text-sm">{t3}<span className="tw-flex tw-flex-nowrap tw-items-center tw-justify-end tw-gap-x-1.5 tw-whitespace-nowrap">{t4}{t5}{t6}</span></div>;
    $[9] = t4;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsDialogOpen(false);
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isDialogOpen || $[13] !== tokenIds) {
    t9 = <WaveRatingCardSetTdhDialog isOpen={isDialogOpen} onClose={t8} tokenIds={tokenIds} />;
    $[12] = isDialogOpen;
    $[13] = tokenIds;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <>{t7}{t9}</>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}